
export const API_URL = "https://quickfeed-backend.onrender.com";
